import { getCountertopRunIsland } from './get-countertop-run-island';

import type { Countertop } from '../../countertops/countertop.class';
import type { CountertopRun } from '../types';

/**
 * Extents of the countertop run in the panel-relative coordinate space `Breakpoint.center`
 * uses (0 = front panel centre). Length is the COUNTERTOP measurement, overhangs included --
 * `guide-2026:436` settles that measurements are taken by countertop, not base.
 * @param countertop the countertop to measure
 * @returns left/right boundaries and length, or null when the island or front panel is unresolvable
 */
export const getCountertopRun = (countertop: Countertop): CountertopRun | null => {
	const island = getCountertopRunIsland(countertop);
	const frontPanel = island?.panels?.getFrontPanel() ?? null;
	if (!frontPanel) return null;

	const length = countertop.getCountertopWidthForPanel(frontPanel.id);
	if (!length || length <= 0) return null;

	const offset = countertop.getCountertopCenterOffsetForPanel(frontPanel.id) ?? 0;
	const halfLength = length / 2;

	return { left: offset - halfLength, right: offset + halfLength, length };
};
